import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSiteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-6.857h-.056c.104.205.218.452.321.725.278.739.53 1.82.081 2.775-.413.88-1.126 1.109-1.658 1.246l-.077.02c-.517.133-.731.189-.886.423-.144.22-.118.495.046 1.029l.037.12c.065.207.143.455.183.688.05.29.064.654-.119 1.005s-.425.59-.71.745a2.4 2.4 0 0 1-.76.24l-.078.014c-.41.072-.617.108-.817.322-.156.168-.254.459-.31.883-.023.172-.037.344-.051.52l-.008.094a5 5 0 0 1-.079.606l-.029.126A6.84 6.84 0 0 0 8 14.857a6.8 6.8 0 0 0 3.49-.954c-.09-.09-.193-.2-.294-.327-.271-.341-.622-.923-.5-1.608.058-.328.234-.604.407-.818.175-.217.388-.419.574-.59l.128-.117c.143-.13.265-.243.37-.353q.096-.1.142-.167a.3.3 0 0 0 .036-.06c.058-.192-.012-.332-.096-.397-.062-.048-.223-.12-.51.061a10 10 0 0 1-.29.18c-.06.034-.18.105-.313.134a.61.61 0 0 1-.725-.41.7.7 0 0 1-.033-.23c0-.047.005-.094.009-.127l.01-.09c.03-.24.072-.594-.065-1.122-.11-.424-.272-.747-.436-1.077-.076-.152-.153-.305-.225-.47-.1-.229-.21-.526-.191-.842.022-.365.208-.663.506-.887.363-.272.818-.894 1.213-1.524.188-.302.35-.583.464-.79l.027-.047A6.83 6.83 0 0 0 8 1.143"
    />
  </svg>
);
export default SvgSiteIcon;
